import React from 'react';
import ActionButton from '~components/atoms/ActionButton';
import Table from '~components/molecules/Table';
import UtilFunctions from '~utils/functions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import { MetalTypeEnum, ModuleEnum, PermissionsEnum, ProjectChangeHistoryStatusEnum } from '~utils/enums';

import * as Styles from './_projectApprovalTableStyles.module.scss';
import combinedActions from '~redux/combinedActions';
import { TUpdateProjectStatusReduxParams } from '~types/feat/approval';

const ProjectApprovalTable = () => {
    const dispatch = useAppDispatch();

    const {
        Misc:
        {
            dateTimeFormat,
            renderPendingProjectStatusChip,
        },
    } = UtilFunctions;

    const pendingProjectListing = useAppSelector(state => state.approval.pendingProjectListing.data);
    const getPendingProjectIsLoading = useAppSelector(state => state.approval.loadings.getPendingProjectListing);

    const access = useAppSelector(state => state.auth.userDetails.access);
    const hasEditAccess = access.find(item => item.permission === PermissionsEnum.Edit)?.modules.find(module => module === ModuleEnum.Approval);

    const setTempUpdateProjectState = (data: TUpdateProjectStatusReduxParams) => dispatch(combinedActions.approvalSetTempUpdateProjectState(data));
    const setConfirmUpdateStatusModalIsOpen = (open: boolean) => dispatch(combinedActions.approvalSetConfirmUpdateProjectStatusModalIsOpen(open));

    const handleApproveClick = (data: TUpdateProjectStatusReduxParams) => {
        setConfirmUpdateStatusModalIsOpen(true);
        setTempUpdateProjectState(data);
    };

    const handleRejectClick = (data: TUpdateProjectStatusReduxParams) => {
        setConfirmUpdateStatusModalIsOpen(true);
        setTempUpdateProjectState(data);
    };

    const tableHeader = [
        'PROJECT ID',
        'PROJECT NAME',
        'EARMARK QUANTITY (RM)',
        'MATURITY PERIOD (YEARS)',
        // 'STATUS',
        'CREATED AT',
        'ACTION',
    ];

    const renderActionButton = (id: number, status:ProjectChangeHistoryStatusEnum ) => {
        if (status === ProjectChangeHistoryStatusEnum.Pending){
            return (
                <div
                    className={Styles['action-button-container']}
                >
                    {hasEditAccess
                    && (
                        <ActionButton
                            label='Approve'
                            onClick={() => handleApproveClick({ id, status: ProjectChangeHistoryStatusEnum.Approved })}
                            className={`${Styles['action-button']} ${Styles.approve}`}
                        />
                    )
                    }

                    {hasEditAccess
                    && (
                        <ActionButton
                            label='Reject'
                            onClick={() => handleRejectClick({ id, status: ProjectChangeHistoryStatusEnum.Rejected })}
                            className={`${Styles['action-button']} ${Styles.reject}`}
                        />
                    )
                    }
                </div>
            );
        }

        return '-';

    };

    const tableBody = pendingProjectListing.map((item) => {
        const {
            id,
            projectId,
            projectName,
            earmarkAmount,
            earmarkEndDate,
            metalType,
            status,
            createdAt,
        } = item;

        const isGold = metalType === MetalTypeEnum.Gold;

        return {
            className: isGold ? Styles['gold-row'] : '',

            cells: [
                projectId,
                projectName,
                earmarkAmount,
                earmarkEndDate,
                createdAt ? dateTimeFormat(createdAt) : '-',
                renderActionButton(id, status),
            ],
        };
    });

    return (
        <Table
            header={tableHeader}
            body={tableBody}
            isLoading={getPendingProjectIsLoading}
        />
    );
};

export default ProjectApprovalTable;
